import { IMessageHandler } from "../message-handler";
import { IHandlerContext } from "../handler-context";
import { StorageMessage, StorageResponse } from "../../crypto/crypto-types";

interface ListUsersRequest {}

interface ListUsersResponse {
  users: Array<{
    id: string;
    username: string;
    createdAt: string;
    lastLogin: string;
    loginCount: number;
  }>;
}

export class ListUsersHandler implements IMessageHandler<ListUsersRequest> {
  constructor(private context: IHandlerContext) {}

  canHandle(type: string): boolean {
    return type === "LIST_USERS";
  }

  async handle(message: StorageMessage<ListUsersRequest>, source: Window, origin: string): Promise<void> {
    const users = await this.context.dbService.getAllUsers();
    // Return safe user data (no sensitive information)
    const safeUsers = users.map(user => ({
      id: user.id,
      username: user.username,
      createdAt: user.createdAt,
      lastLogin: user.lastLogin,
      loginCount: user.loginCount
    }));

    const response: StorageResponse<ListUsersResponse> = {
      type: 'RESPONSE',
      data: { users: safeUsers },
      requestId: message.requestId
    };
    this.context.sendResponse(source, response, origin, message.requestId);
  }
}
